export interface DocumentDescription {
    name: string;
    mFileIds: string[];
    locale: "fi" | "en";
    excerpt: TrustedHTML | string;
    description?: TrustedHTML | string;
}

const electricityRetailMarketBusinessProcesses: DocumentDescription[] = [
    {
        name: "Sähkön vähittäismarkkinoiden liiketoimintaprosessit datahubissa",
        mFileIds: [
            "0-445042-1-592643",
            "0-473931-1-633322",
            "0-504318-1-674927", // V2.4 / Tuotanto
        ],
        locale: "fi",
        excerpt: `
            Dokumentissa kuvataan ne sähkön vähittäismarkkinoiden liiketoimintaprosessit, jotka hoidetaan datahubin kautta. 
            Dokumentti käsittelee prosessien toimintaperiaatteet ja -säännöt sekä osapuolten oikeudet tarvittaviin tietoihin.
        `,
        description: `
            <p>
                Dokumentin johdanto sisältää tietoa datahubin toimintaa koskevasta lainsäädännöstä sekä tiedonvaihdon kehityksestä datahubin myötä. 
                Se sisältää myös osapuolten liiketoimintakuvaukset datahub-ympäristössä, prosessikartan sekä UML-kuvausten lukuohjeet.
            </p>
            <p>
                Luvussa 2 ”Datahubin tietomalli ja osapuolten oikeudet tietoon” kuvataan markkinaprosessien vaatimukset datahubin sisäiselle 
                tietomallille sekä datahubin päätietoryhmät. Luvussa käsitellään myös kunkin datahubin osapuolen oikeudet tietoihin, tietojen 
                säilytysaikaa sekä osapuolten käyttöliittymää ja tietorajapintaa.
            </p>
            <p> Luvussa 3 kuvataan markkinaprosessit ja toimintamallit:</p>
                <ul>
                    <li>DH-100 Asiakas-, käyttöpaikka- ja energiayhteisötiedon hallinta</li>
                    <li>DH-200 Mittaustiedon käsittely</li>
                    <li>DH-300 Sopimusprosessit</li>
                    <li>DH-400 Kytkentä- ja katkaisu prosessit</li>
                    <li>DH-500 Jakeluverkonhaltijan taseselvitys</li>
                    <li>DH-600 Tasevirheiden käsittely</li>
                    <li>DH-710 ja DH-720 Tuotetietojen ylläpito ja haku</li>
                    <li>DH-730 ja DH-740 Laskurivitietojen ilmoitus ja haku</li>
                    <li>DH-800 Valtuutukset ja toimeksiannot</li>
                    <li>DH-900 Osapuolitietojen ylläpito</li>
                </ul>
            </p>
            <p>
                Luvussa käydään läpi, miten osapuolet hakevat ja ilmoittavat tietoa datahubiin ja miten tieto välitetään muille osapuolille osana markkinaprosesseja. Prosessit on kuvattu osapuolten liiketoiminnan näkökulmasta. Tarkemmat tapahtumakohtaiset kuvaukset löytyvät Datahub-tapahtumat-dokumentista. 
                Lisäksi dokumentti sisältää tietoa mittausalueen rakenteellisista muutoksista, asiakkaan pääsystä omiin tietoihinsa, energiatehokkuuslain edellyttämästä raportoinnista, Datahub-operaattorin suorittamista korjauksista sekä prosessiketjuista datahub-järjestelmässä. 
                Dokumentin liitteenä on taseselvityslaskentojen kuvaukset.
            </p>
        `,
    },
    {
        name: "Electricity retail market business processes in Datahub",
        mFileIds: [
            "0-445047-1-592649",
            "0-473969-1-633367",
            "0-504323-1-674932", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            This document outlines the business processes of the electricity retail market that are handled through Datahub. 
            It provides descriptions of processes and rules and specifies each party’s rights to information.
        `,
        description: `
            <p>
                The introduction describes the legislation behind Datahub's operation as well as the development of information exchange through 
                Datahub. It contains business descriptions for the parties using Datahub, a process map and reading instructions for UML descriptions.
                Chapter 2, ”Datahub's data model and parties' rights to data”, describes the requirements market processes pose on Datahub's internal 
                data model. It also specifies the model's different entities. Furthermore, it covers the rights of each party to information, data 
                retention periods and the market parties' user interface and data interface. Chapter 3 details the following business processes:
            </p>
            <p>
                <ul>
                    <li>DH-100 Management of customer, accounting point and energy community data</li>
                    <li>DH-200 Processing metering data</li>
                    <li>DH-300 Agreement processes</li>
                    <li>DH-400 Connection and disconnection processes</li>
                    <li>DH-500 Distribution system operator's imbalance settlement</li>
                    <li>DH-600 Management of balance deviation</li>
                    <li>DH-710 and DH-720 Maintenance and retrieval of product data</li>
                    <li>DH-730 and DH-740 Maintenance and retrieval of invoice row data</li>
                    <li>DH-800 Authorisations and delegations</li>
                    <li>DH-900 Maintaining party information</li>
                </ul>
            </p>
            <p>
                This description includes the principles for how parties retrieve and report information to Datahub and how the information is sent 
                to other parties as part of the market processes. The processes are covered from a business operations point of view. More detailed 
                event-specific descriptions are provided in the Datahub Events document.
                Additionally, the document contains information on structural changes to metering grid areas, customers' access to their own data, 
                reporting required by the Energy Efficiency Act, corrections made by the Datahub operator and r composite processes in the Datahub 
                system. The document's appendix contains descriptions of imbalance settlement calculations.
            </p>
        `,
    },
];

const electricityRetailMarketBusinessProcessesChanges: DocumentDescription[] = [
    {
        name: "Sähkön vähittäismarkkinoiden liiketoimintaprosessit datahubissa MUUTOKSET",
        mFileIds: [
            "0-445043-1-592644",
            "0-473930-1-633321",
            "0-504324-1-674933", // Tuotanto
        ],
        locale: "fi",
        excerpt: `
            Muutokset edelliseen versioon korostettuina.
        `,
    },
    {
        name: "Electricity retail market business processes in Datahub CHANGES",
        mFileIds: [
            "0-445048-1-592650",
            "0-473970-1-633368",
            "0-504322-1-674931", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            Changes compared to the previous version highlighted.
        `,
    },
];

const datahubEvents: DocumentDescription[] = [
    {
        name: "Datahub tapahtumat",
        mFileIds: [
            "0-445033-1-592633",
            "0-473910-1-633301",
            "0-504321-1-674930", // Tuotanto
        ],
        locale: "fi",
        excerpt: `
            Dokumentti sisältää yleiset rajapintamääräykset, datahub-tapahtumien tarkat kuvaukset sekä sanomatyyppien kuvaukset.
        `,
        description: `
        <p>
            Dokumentti sisältää kattavan kuvauksen Datahubin tapahtumista ja sanomatyypeistä. Se kattaa seuraavat pääkohdat:
        </p>
        <p>
            <ul>
                <li>Yleiset rajapintamääritykset: Nimiavaruus, versiointi, sanomarakenne, yleiset elementit, sanomavalidoinnit, kuittauskäsittely, 
                kyselytapahtumat, sanomalistat, peruutussanomat ja -tapahtumat, tapahtumien välitys, tapahtumien nouto, tapahtumien 
                synkronisuus/asynkronisuus, sanomaliikenteen salaus ja pakkaus, alkuperäisen sanoman tunnus ja lähettäjä, rakenteellisten 
                tietojen päivitykset sekä toimeksiannot.</li>
                <li>Datahub tapahtumien kuvaukset:
                    <ul>
                        <li>DH-100 Asiakas-, käyttöpaikka- ja energiayhteisötietojen ylläpitoprosessit</li>
                        <li>DH-200 Mittaustiedon ylläpitoprosessit</li>
                        <li>DH-300 Sopimusprosessit</li>
                        <li>DH-400 Kytkentä- ja katkaisuprosessit</li>
                        <li>DH-500 Taseselvitys</li>
                        <li>DH-600 Tasevirheiden korjaus</li>
                        <li>DH-700-Tuote- ja laskutustiedon ylläpitoprosessit</li>
                        <li>DH-800 Valtuutukset</li>
                        <li>DH-900 Osapuolitiedot</li>
                    </ul>
                </li>
                <li>Sanomatyyppien kuvaukset: Otsikko, prosessi, tapahtumatiedot, ACK kuittaustapahtuma ja noutotapahtuma. </li>
            </ul>
        </p>
    `,
    },
    {
        name: "Datahub events",
        mFileIds: [
            "0-445044-1-592646",
            "0-473958-1-633352",
            "0-504320-1-674929", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            This document contains general interface specifications and detailed descriptions of Datahub events and message types.
        `,
        description: `
            <p>
                This document provides a comprehensive description of Datahub events and message types. It covers the following key points:
            </p>
            <p>
                <ul>
                    <li>General interface specifications: Namespace, versioning, message structure, general elements, message validations, 
                    acknowledgment handling, enquiry events, message lists, cancellation messages and events, event forwarding, request events, 
                    event synchronicity/asynchronicity, message encryption and packing, original message ID and sender, structural data updates 
                    and delegations.</li>
                    <li>Descriptions of Datahub events:
                        <ul>
                            <li>DH-100 Customer, accounting point and energy community data maintenance processes</li>
                            <li>DH-200 Metering data maintenance processes</li>
                            <li>DH-300 Agreement processes</li>
                            <li>DH-400 Connection and disconnection processes</li>
                            <li>DH-500 Imbalance settlement</li>
                            <li>DH-600 Balance deviation correction</li>
                            <li>DH-700 Product and invoicing information maintenance processes</li>
                            <li>DH-800 Authorisations</li>
                            <li>DH-900 Party information</li>
                        </ul>
                    </li>
                </ul>
            </p>
        `,
    },
];

const datahubEventChanges: DocumentDescription[] = [
    {
        name: "Datahub tapahtumat MUUTOKSET",
        mFileIds: [
            "0-445039-1-592639",
            "0-473917-1-633308",
            "0-504329-1-674938", // Tuotanto
        ],
        locale: "fi",
        excerpt: `
            Muutokset edelliseen versioon korostettuina.
        `,
    },
    {
        name: "Datahub events CHANGES",
        mFileIds: [
            "0-445046-1-592648",
            "0-473959-1-633353",
            "0-504319-1-674928", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            Changes compared to the previous version highlighted.
        `,
    },
];

const dataStandard: DocumentDescription[] = [
    {
        name: "Datahub DataStandard",
        mFileIds: [
            "0-445041-1-592641",
            "0-473943-1-633334",
            "0-495030-1-662174", // Tuotanto
        ],
        locale: "fi",
        excerpt: `
            <p>
                Datastandardi-taulukko sisältää tarkemman tason kuvauksen datahubin tietomallista tietokokonaisuuksien (entiteettien) ja niihin 
                liittyvien ominaisuuksien (attribuuttien) osalta. Taulukossa on avattu tarvittavien tietojen käyttötarkoitusta, sallittuja arvoja 
                sekä ehtoja ja riippuvuuksia tiedoille. Lisäksi datastandardiin on lisätty käytettävien sanomatyyppien tiedot. 
            </p>
            <p>
                The data standard table contains a detailed description of the Datahub data model, including entities and attributes. 
                The table details the intended use, allowed values as well as conditions and dependencies for the data. Additionally, 
                the data standard includes information on the message types used.
            </p>
        `,
    },
];

const datahubProcessMap: DocumentDescription[] = [
    {
        name: "Datahub Prosessikartta",
        mFileIds: [
            "0-445050-1-592653",
            "0-473973-2-633372",
            "0-495025-1-662169", // Tuotanto
        ],
        locale: "fi",
        excerpt: `
            Dokumentti sisältää sähkön vähittäismarkkinoiden liiketoimintaprosessit koottuna karttaan.
        `,
        description: `
            <p>
                Kartassa on kuvattu seuraavat liiketoimintaprosessit:
            </p>
            <ul>
                <li>DH-100 - Asiakas-, käyttöpaikka- ja energiayhteisötiedon ylläpitoprosessit</li>
                <li>DH-200 - Mittaustiedon ylläpitoprosessit</li>
                <li>DH-300 - Sopimusprosessit</li>
                <li>DH-400 - Kytkentä- ja katkaisuprosessit</li>
                <li>DH-500 - Taseselvitys</li>
                <li>DH-600 - Tasevirheiden korjaus</li>
                <li>DH-700 - Tuote- ja laskutustiedon ylläpitoprosessit</li>
                <li>DH-800 - Asiakkaan valtuutukset</li>
                <li>DH-900 - Osapuolitiedot</li>
            </ul>
            <p>
                Liiketoimintaprosessit on kuvattu nuolilla osapuolten välille.
            </p>
        `,
    },
    {
        name: "Datahub Process map",
        mFileIds: [
            "0-445051-1-592654",
            "0-473974-2-633373",
            "0-495024-1-662168", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            This document contains Datahub's business processes as a map.
        `,
        description: `
            <p>
                The map describes the following business processes:
            </p>
            <ul>
                <li>DH-100 Customer, accounting point and energy community data maintenance processes</li>
                <li>DH-200 Metering data maintenance processes</li>
                <li>DH-300 Agreement processes</li>
                <li>DH-400 Connection and disconnection processes</li>
                <li>DH-500 Imbalance settlement</li>
                <li>DH-600 Balance deviation correction</li>
                <li>DH-700 Product and invoicing information maintenance processes</li>
                <li>DH-800 Authorisations</li>
                <li>DH-900 Party information</li>
            </ul>
            <p>
                The business processes are depicted with arrows between the parties.
            </p>
        `,
    },
];

const processDiagrams: DocumentDescription[] = [
    {
        name: "Prosessikaaviot",
        mFileIds: [
            "0-250988-1-325605", // v1.13 / Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Tähän dokumenttiin on koottu seuraavat Datahubin prosessikaaviot: asiakastietojen päivitys, käyttöpaikkatietojen päivitys, 
            uusi sopimus, takautuva sopimus, myyntisopimuksen päättäminen, verkkosopimuksen päättäminen, uuden myyjän muuttoilmoitus, 
            myyntisopimuksen peruutus, verkkosopimuksen peruutus, kytkentä, katkaisu ja katkaisupyynnön peruutus.
        `,
    },
    {
        name: "Process diagrams",
        mFileIds: [
            "0-250989-1-325606", // V1.13 / Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document includes the following Datahub process diagrams: customer information update, accounting point data update, 
            new agreement, retrospective new agreement, sales agreement end, grid agreement end, move out by new supplier, sales agreement 
            cancellation, grid agreement cancellation, connection, disconnection, cancel disconnection request.
        `,
    },
];

const memoOnSynteticTestData: DocumentDescription[] = [
    {
        name: "Muistio synteettisen testiaineiston käyttövaatimuksesta",
        mFileIds: [
            "0-228858-1-289237", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Muistio määrittelee testiaineiston käyttöön liittyvät periaatteet ja reunaehdot sidosryhmätestauksessa ja tuotantokäytön varmistamisessa. 
            Synteettisen testiaineiston käyttövaatimus perustuu tietosuojalainsäädäntöön.
        `,
    },
];

const marketPartyTestGuide: DocumentDescription[] = [
    {
        name: "Markkinaosapuolten testausohje",
        mFileIds: [
            "0-238242-1-305841", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Dokumentti toimii markkinaosapuolten oppaana datahubin testauksen aloittamiseen. Se sisältää tietoa testaamisesta, periaatteista 
            käytettävälle tiedolle testauksessa, yhteyksistä ja pääsystä datahubin testiympäristöön, yleisistä taustaperiaatteista ja 
            rajapintaohjeista.
        `,
    },
    {
        name: "Datahub Market party testing guide",
        mFileIds: [
            "0-235958-1-300773", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document guides market parties when starting testing in Datahub. It contains information on testing, data principles, 
            connection and access to the test environment, as well as general testing principles and interface guidelines.
        `,
    },
];

const b2bMessageInterfaceConnection: DocumentDescription[] = [
    {
        name: "B2B-sanomarajapinta yhteyden muodostaminen",
        mFileIds: [
            "0-269008-1-349365", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Dokumentti sisältää ohjeen B2B-käyttäjien ja rajapintayhteyden luontiin. Dokumentti koostuu esitiedoista ja -ehdoista sekä ohjeista 
            IP-osoitteiden ilmoittamiseen, varmenteen hankkimiseen, B2B-käyttäjän ja järjestelmäkäyttäjän luomiseen, muutosten tekemiseen, 
            yhteyden muodostamiseen datahubiin sekä toimeksiantoihin.
        `,
    },
];

const datahubReleaseNotes: DocumentDescription[] = [
    {
        name: "Datahub Julkaisutiedot - Release Notes",
        mFileIds: [
            "0-434752-4-579622", // V2.2 / Testi
            "0-482015-1-644881", // V2.3 / Tuotanto
        ],
        locale: "fi",
        excerpt: `
            <p>Dokumentti sisältää datahubin julkaisutiedot.</p>
            <p>This document contains the release notes for Datahub</p>
        `,
        description: `
            <p>
                Dokumentista löytyy datahubin julkaisutiedot. Dokumentissa on luettelo, 
                joka sisältää julkaisun osana toimitetun laajuuden. Toisessa luettelossa on kaikki julkaisussa ratkaistut viat. 
            </p>
            <p>
                This document contains the release notes for Datahub. The document includes a list of the scope delivered as part of 
                the release. Another list contains all resolved defects of the release.
            </p>
        `,
    },
];

const datahubFingridSchemas: DocumentDescription[] = [
    {
        name: "Datahub_Fingrid_Schemas",
        mFileIds: [
            "0-446968-1-595256",
            "0-460436-1-614804",
            "0-488809-1-654180", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            <p>Datahub-järjestelmän skeemakuvaukset</p>
            <p>Datahub schema descriptions</p>
        `,
    },
];

const datahubDataInterface: DocumentDescription[] = [
    {
        name: "Datahub Tietorajapinta",
        mFileIds: [
            "0-228850-1-289229",
            "0-502400-2-672172", // Tuotanto
        ],
        locale: "fi",
        excerpt: `
            Dokumentti kuvaa datahubin REST API -tiedonhakurajapinnan.
        `,
    },
    {
        name: "Datahub Data Interface",
        mFileIds: [
            "0-228854-1-289233",
            "0-502401-2-672173", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            This document describes Datahub's REST API data interface.
        `,
    },
];

const datahubExternalInterfaceSpec: DocumentDescription[] = [
    {
        name: "Datahub External Interface Specification",
        mFileIds: [
            "0-228849-1-289228", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document describes the technical implementation of Datahub's B2B SOAP interface. It is intended as a guide for application 
            developers and/or integration specialists implementing an integration between Datahub and an external system. 
        `,
    },
];

const datahubValidationRules: DocumentDescription[] = [
    {
        name: "Datahub Validation Rules",
        mFileIds: [
            "0-331936-1-436255",
            "0-495766-1-663206", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            This document includes Datahub validation rules for the following elements: General messaging, Energy communities, Energy community members, 
            Accounting points, Metering grid areas, Accounting point addresses, Estimated yearly usages, Controlled load, Storage devices, Production services, 
            Channels, Agreements (general), Agreements (sales), Agreements (grid), Agreements (authorisation), Customers, Customer postal addresses, Agreement contacts, 
            Connection contacts, Postal invoicing addresses, Electronic invoicing addresses, Other invoicing addresses, Product, Product name, Product component, 
            Product component data, Price data, Time series value data, Invoice rows, Organisations, Organisation addresses, Organisation contacts, Balance settlement connections, 
            Virtual product units, Production units, Balance responsibilities and User identities.
        `,
    },
];

const validationRulesDH200: DocumentDescription[] = [
    {
        name: "Validation Rules - DH-200",
        mFileIds: [
            "0-248787-1-322940",
            "0-500417-2-669685", // Tuotanto
        ],
        locale: "en",
        excerpt: `
            The document describes the error codes returned by Datahub for the DH-200 processes.
        `,
    },
];

const datahubNameAndAddressStructureGuide: DocumentDescription[] = [
    {
        name: "Datahub Nimi- ja Osoiterakenneohje",
        mFileIds: [
            "0-227065-1-287100", // 1.0 / Testi
            "0-480926-2-643633", // 2.0 / Tuotanto
        ],
        locale: "fi",
        excerpt: `
            Ohjeessa kuvataan datahubissa käytettävät harmonisoidut osoiterakenteet, joiden käyttöönoton avulla osapuolten kesken vaihdettavien tietojen laatua voidaan parantaa. 
            Tietorakenteiden lisäksi ohjeessa annetaan lukuisia esimerkkejä ja tarkentavia ohjeita erilaisista osoitteiden oikeista rakenteista datahubissa.
        `,
        description: `
            <p>
                Tämän ohjeen tarkoitus on kuvata datahubissa käytettävät harmonisoidut osoiterakenteet sekä ohjeet nimien kirjoituksesta, 
                joiden käyttöönoton avulla osapuolten kesken vaihdettavien tietojen laatua voidaan parantaa. Tietorakenteiden 
                lisäksi tässä ohjeessa annetaan lukuisia esimerkkejä ja tarkentavia ohjeita erilaisista osoitteiden oikeasta rakenteesta 
                sekä nimien kirjoitusasusta datahubissa. Tässä dokumentissa on keskitytty ohjeistamaan suomalaisten osoitteiden kirjoitusasua. 
                Ulkomaalaisten osoitteiden osalta tulee varmistaa, että osoite kirjoitetaan sellaisessa muodossa, joka sopii datahubiin 
                ilmoitettaviin tietokenttiin sekä muodon että pituutensa puolesta. 
            </p>
        `,
    },
    {
        name: "Datahub name and address structure guide",
        mFileIds: [
            "0-267021-1-344727", // 1.0 / Testi
            "0-481067-1-643817", // 2.0 / Tuotanto
        ],
        locale: "en",
        excerpt: `
            This guide describes the harmonised address structures used in Datahub. It also provides guidelines for names. 
            The aim of the harmonisation is to improve the quality of data exchanged between parties. In addition to data structures, 
            there are numerous examples and detailed instructions on various correct address structures and name formats. This document 
            focuses on providing guidance for writing Finnish addresses. For foreign addresses, it is important to ensure that the address 
            is written in a format that fits the data fields used by Datahub in terms of both form and length. 
        `,
    },
];

const datahubSupportServiceInstructions: DocumentDescription[] = [
    {
        name: "Datahub-tukipalvelun käyttöohje",
        mFileIds: [
            "0-229554-1-290764", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Dokumentti sisältää ohjeen datahub-tukipalvelun käyttöönottoon ja sinne kirjautumiseen, kaksivaiheiseen tunnistautumiseen, tukipyynnön tekemiseen ja tietämyskannan käyttöön. 
            Lisäksi dokumentista löytyy pääkäyttäjäohje käyttäjähallintaan sekä ohje partner-yhtiöille.
        `,
        description: `
            <p>
                Tämä dokumentti sisältää datahub-tukipalvelun käyttöohjeen. Dokumentissa kuvataan:
            </p>
            <p>
                <ul>
                    <li>Datahub-tukipalvelun käyttöönotto ja sinne kirjautuminen</li>
                    <li>Kaksivaiheinen tunnistautuminen</li>
                        <ul>
                            <li>autentikointisovelluksen käyttöönotto selaimelle</li>
                            <li>autentikointisovelluksen käyttöönotto</li>
                            <li>autentikointisovelluksen vaihtaminen uuteen laitteeseen</li>
                        </ul>
                    <li>Tukipyynnön tekeminen</li>
                        <ul>
                            <li>Ota yhteyttä palvelulomakkeella</li>
                            <li>Kaikki palvelupyyntöni</li>
                            <li>Ratkaistu pyyntö</li>
                        </ul>
                    <li>Tietämyskanta</li>
                    <li>Pääkäyttäjäohje käyttäjähallintaan</li>
                        <ul>
                            <li>Rekisteröintipyyntöjen hyväksyntä</li>
                            <li>Käyttäjien hallinta</li>
                        </ul>
                    <li>Partner-yhtiöt</li>
                        <ul>
                            <li>Partneryhtiötili - hallinta ja rakenne</li>
                            <li>Yhtiökäyttäjien hallinta / ensisijainen yhtiö</li>
                            <li>Yhtiökäyttäjien hallinta / kumppaniyhtiö</li>
                            <li>Tikettien tekeminen edustettujen osapuolten nimissä partner-pääkäyttäjänä</li>
                        </ul>
                </ul>
            </p>
        `,
    },
    {
        name: "Datahub Support Service instructions",
        mFileIds: [
            "0-229555-1-290765", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document contains instructions for setting up and logging into the Datahub Support Service, two-factor authentication, 
            submitting support requests and using the knowledge base. Additionally, the document contains an admin guide for user management 
            and instructions for partner companies.
        `,
        description: `
            <p>
                This document serves as an introduction to the Datahub Support Service. Contents include:
            </p>
            <p>
                <ul>
                    <li>How to start using the Datahub Support Service and how to sign into the service portal</li>
                    <li>Multi Factor Authentication</li>
                        <ul>
                            <li>Using an authenticator app in the web browser</li>
                            <li>Using an authenticator app</li>
                            <li>How to change or reinstall the authenticator app (e.g., when changing device)</li>
                        </ul>
                    <li>How to create a support request</li>
                        <ul>
                            <li>The contact form</li>
                            <li>All own service requests</li>
                            <li>Resolved request</li>
                        </ul>
                    <li>Knowledge base</li>
                    <li>Administrator instruction for user administration</li>
                        <ul>
                            <li>Acceptance of the registration request</li>
                            <li>User administration</li>
                        </ul>
                    <li>Partner companies</li>
                        <ul>
                            <li>Partner company account – management and structure</li>
                            <li>User administration / primary company (partner)</li>
                            <li>User administration / secondary company</li>
                            <li>Making a ticket on behalf of another party as a partner administrator</li>
                        </ul>
                </ul>
            </p>
        `,
    },
];

const inferringProcesses: DocumentDescription[] = [
    {
        name: "Risteävät prosessit",
        mFileIds: [
            "0-249459-1-323863", // Tuot
        ],
        locale: "fi",
        excerpt: `
           Dokumentissa käsitellään eri datahub-tapahtumien riippuvuuksia toisiinsa näiden kohdistuessa samaan aikaan samalle käyttöpaikalle.
        `,
        description: `
            <p>
                Dokumentti kuvaa sellaisia datahub-järjestelmässä käsiteltäviä sopimustapahtumien esiintymiä 
                (ilmoitus- ja voimassaoloajoituksia), joille voi muodostua kilpailevia ja ajallisesti risteäviä tapahtumia.
            </p>
            <p>
                Risteävät tapaukset luokitellaan seuraavasti:
                <ul>
                    <li>ei mahdollinen tai ei risteä</li>
                    <li>hyväksyttävä risteävyys</li>
                    <li>hyväksyttävissä säännöillä</li>
                    <li>risteävyys, jota ei voida hyväksyä</li>
                </ul>
            </p>
            <p>
                Tapahtumat esitetään matriisimuodossa, jossa luetellaan mahdolliset risteävyyksiä aiheuttavat 
                tapahtumat ja vertaillaan niiden ajallista järjestystä sekä esiintymisen alkamisajankohtaa.
            </p>
        `,
    },
    {
        name: "Inferring processes",
        mFileIds: [
            "0-246772-2-319556", // Tuot
        ],
        locale: "en",
        excerpt: `
           This document describes the dependencies of Datahub events when interfering timely with each other at the same 
           accounting point.
        `,
        description: `
            <p>
                This document lists possible interfering events in Datahub and contains comparisons of the event order and the start of occurrence.
                The interfering cases are classified as:

                <ul>
                    <li>not possible or not interfering</li>
                    <li>acceptable interfering</li>
                    <li>acceptable with rules</li>
                    <li>not acceptable interfering</li>
                </ul>
            </p>
        `,
    },
];

const partysContactPersonManagement: DocumentDescription[] = [
    {
        name: "Osapuolen yhteyshenkilön ylläpito",
        mFileIds: [
            "0-282423-2-371478", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohje osapuolen yhteyshenkilön ylläpitoon ja luontiin datahubin käyttöliittymässä.
        `,
    },
    {
        name: "Party's contact person information management",
        mFileIds: [
            "0-282601-1-371688", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            Instructions on how to create and update contact persons in the Datahub CMS (GUI).
        `,
    },
];

const partyRetrievalFromDatahub: DocumentDescription[] = [
    {
        name: "Osapuolitietojen haku datahubista",
        mFileIds: [
            "0-322254-1-422597", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohje osapuolitietojen hakuun ja ylläpitoon datahubin käyttöliittymässä.
        `,
    },
];

const thirdPartyInstructions: DocumentDescription[] = [
    {
        name: "Datahubin palvelun piirissä olevien kolmansien osapuolten ohjeistus",
        mFileIds: [
            "0-254305-1-331461", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Tässä ohjeistuksessa kuvataan ylätasolla, mitä toimenpiteitä kolmansien osapuolten ja järjestelmätoimittajien tulee tehdä 
            ennen datahubin operatiiviseen käyttöön siirtymistä.
        `,
        description: `
            <p>
                Datahubin palvelun piirissä voi toimia kolmansia osapuolia (3. osapuoli tai palveluntarjoaja), jotka tarjoavat 
                sähkömarkkinaosapuolille (jakeluverkonhaltijoille ja sähkönmyyjille) ja loppuasiakkaille sähkön vähittäismarkkinoiden 
                palveluita toimeksiantojen ja valtuutusten kautta. Kolmannella osapuolella tulee datahubissa toimiakseen aina olla oikeutus 
                tietoihin joko sähkönmyyjän tai jakeluverkonhaltijan antaman toimeksiannon kautta tai loppuasiakkaan antaman 
                valtuutuksen kautta.
            </p>
            <p>
                Ohjeen luvussa 4 kuvataan yleisellä tasolla, miten datahubin sähkön vähittäismarkkinoiden liiketoimintaprosessit 
                vaikuttavat kolmansiin osapuoliin. Luvussa on kaksi osiota: palveluntarjoajan käynnistämät prosessit sekä datahubin 
                ilmoitukset palveluntarjoajalle. Luvussa 7 kuvataan teknistä liityntää.
            </p>
        `,
    },
];

const datahubProcessTimeLimits: DocumentDescription[] = [
    {
        name: "Datahub prosessien aikarajat",
        mFileIds: [
            "0-284734-1-375491", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Dokumenttiin on koostettu datahubin liiketoimintaprosessien aikarajat.
        `,
    },
];

const partiesWithMeasurementResponsibility: DocumentDescription[] = [
    {
        name: "Mittausvastuullisten osapuolten ohjeistus",
        mFileIds: [
            "0-233603-1-296799", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohjeistus sellaisille markkinaosapuolille, jotka eivät ole datahubin varsinaisen palvelun piirissä, 
            mutta joilta edellytetään toimenpiteitä mm. uusien tunnisteiden sekä testaus- ja sertifiointipalvelun osalta. 
            Kaikkia Suomen taseselvityksessä mukana olevia markkinaosapuolia pyydetään huomioimaan ohjeistus omassa toiminnassaan.
        `,
        description: `
            <p>
                Tämä on ohjeistus niille datahub-järjestelmään liittyville markkinaosapuolille, jotka eivät tule olemaan datahubin varsinaisen palvelun piirissä, 
                mutta joilta edellytetään toimenpiteitä mm. uusien tunnisteiden sekä testaus- ja sertifiointipalvelun osalta. 
                Kaikkia Suomen taseselvityksessä mukana olevia markkinaosapuolia pyydetään huomioimaan kyseinen ohjeistus omassa toiminnassaan. 
            </p>
            <p>
                Jos ohjeeseen liittyen herää kysymyksiä, pyydämme toimittamaan ne ensisijaisesti datahubin tukipalvelun kautta. 
                Mikäli yhtiöllänne ei vielä ole pääsyä tukipalveluun, otattehan yhteyttä sähköpostitse datahub@fingrid.fi.
            </p>
        `,
    },
];

const datahubUIUserManualForParties: DocumentDescription[] = [
    {
        name: "Datahubin käyttöliittymän käyttäjäopas markkinaosapuolille",
        mFileIds: [
            "0-387714-2-512440", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Käsikirja datahubin käyttöliittymän käyttöön rakenteellisen tiedon käsittelyyn. Opas tukee datahubin käyttäjää muun muassa 
            käyttöpaikkojen, asiakkaiden ja myyntisopimusten hallinnassa.
        `,
        description: `
            <p>
                Käsikirjassa kuvataan Datahubin käyttöliittymän tarjoama järjestelmätoimintoja, joiden avulla markkinaosapuolet voivat käyttää
                liiketoimintaprosesseja sopimuksen perustietojen hallintaan sopimuksen perustietojen osajärjestelmässä. Dokumentissa käsitellään
                myös raporttien luontia, tasesopimusprosesseja sekä energiayhteisöjen luontia ja ylläpitoa.

                <ul>
                    <li>1. luku: Sopimuksen perustiedot: käyttöpaikat</li>
                    <li>2. luku: Sopimuksen perustiedot: valtuutus</li>
                    <li>3. luku: Sopimuksen perustiedot: asiakkaat</li>
                    <li>4. luku: Sopimuksen perustiedot: markkinatasealue</li>
                    <li>5. luku: Sopimuksen perustiedot: mittausalue</li>
                    <li>6. luku: Sopimuksen perustiedot: rajapiste</li>
                    <li>7. luku: Sopimuksen perustiedot: tuotantoyksikkö</li>
                    <li>8. luku: Sopimuksen perustiedot: osapuolivaltuutus</li>
                    <li>9. luku: Sopimuksen perustiedot: verkkosopimus</li>
                    <li>10. luku: Sopimuksen perustiedot: myyntisopimus</li>
                    <li>11. luku: Sopimuksen perustiedot: tuote</li>
                    <li>12. luku: Sopimuksen perustiedot: tasevastuut</li>
                    <li>13. luku: Tasesopimus, energiayhteisöt</li>
                    <li>14. luku: Raportointi</li>
                </ul>
            </p>
        `,
    },
    {
        name: "Datahub GUI User Manual for Market Parties",
        mFileIds: [
            "0-273593-9-356416", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This is the user manual for the Datahub GUI. It supports the user in managing e.g. accounting points, customers and agreements.
        `,
        description: `
            <p>
                This guide describes the system functionality of the Datahub user interface, which enables market parties to execute business processes for managing their contract master data. 
                The guide also covers reporting, balance agreements and energy community processes.

                <ul>
                    <li>Chapter 1: Contract master data: Accounting points</li>
                    <li>Chapter 2: Contract master data: Authorisation</li>
                    <li>Chapter 3: Contract master data: Customers</li>
                    <li>Chapter 4: Contract master data: Market balance area</li>
                    <li>Chapter 5: Contract master data: Metering grid area</li>
                    <li>Chapter 6: Contract master data: Exchange point</li>
                    <li>Chapter 7: Contract master data: Production unit</li>
                    <li>Chapter 8: Contract master data: Party authorisation</li>
                    <li>Chapter 9: Contract master data: Grid agreement</li>
                    <li>Chapter 10: Contract master data: Sales agreement</li>
                    <li>Chapter 11: Contract master data: Product</li>
                    <li>Chapter 12: Contract master data: Balance responsibilities</li>
                    <li>Chapter 13: Balance agreement</li>
                    <li>Chapter 14: Contract master data: Energy communities</li>
                    <li>Chapter 15: Reporting</li>
                </ul>
            </p>
        `,
    },
];

const datahubControlReports: DocumentDescription[] = [
    {
        name: "Datahub Control Reports",
        mFileIds: [
            "0-387715-1-512442", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document describes the basic functionalities, sources for and contents of the control reports available in the Datahub GUI.
        `,
    },
];

const datahubGUIMDMUserManualForMarketParties: DocumentDescription[] = [
    {
        name: "Datahub GUI MDM User Manual for Market Parties",
        mFileIds: [
            "0-279111-6-366784", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This Datahub GUI MDM user manual for market parties describes meter data management and is an extension to the Datahub GUI user manual for market parties. 
            Contents include Meter data submissions, Meter data requests, Meter data forwarding options, Meter data comparison and Reporting.
        `,
    },
];

const datahubGUISMTUserManualForMarketParties: DocumentDescription[] = [
    {
        name: "Datahub GUI SMT User Manual for Market Parties",
        mFileIds: [
            "0-279112-5-366785", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This Datahub GUI SMT user manual for market parties describes settlement processes and is an extension to the Datahub GUI user manual for market parties. 
            Contents include Imbalance settlement, Balance deviation, Settlement runs, Settlement time series, Reporting and Dashboards.
        `,
    },
];

const datahubGUIUserManualOfBasicFunctionalitiesForMarketParties: DocumentDescription[] = [
    {
        name: "Datahub GUI User Manual of basic functionalities for Market Parties",
        mFileIds: [
            "0-280252-6-368246", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This guide is an extension to the Datahub GUI User Manual for Market Parties. It covers the most basic functionalities of the Datahub GUI in detail: 
            how to get started, navigation, user management and reporting.
        `,
        description: `
            <p>
                This guide covers the most basic functionalities of the Datahub GUI.
                <ul>
                    <li>Chapter 1: Getting started: access, login, passwords</li>
                    <li>Chapter 2: General principles: navigation, validation, view business transaction details</li>
                    <li>Chapter 3: User management: organisations, users, roles</li>
                    <li>Chapter 4: Reporting: interactive and downloadable reports</li>
                    <li>Chapter 5: Follow up: peek and dequeue messages, list open transactions</li>
                </ul>
            </p>
        `,
    },
];

const sslCertificateRetrievalInstructions: DocumentDescription[] = [
    {
        name: "Datahubin B2B-varmenteen hakuohje",
        mFileIds: [
            "0-238243-1-305842", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohje datahubin B2B-/SSL-varmenteen hakemiseen, asentamiseen, uusimiseen ja sulkemiseen.
        `,
    },
    {
        name: "Instruction to retrieve SSL-certificate",
        mFileIds: [
            "0-235960-1-300775", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document covers the retrieval, installation, renewal and revocation of the Datahub SSL certificate.
        `,
    },
];

const b2BUserCreation: DocumentDescription[] = [
    {
        name: "B2B-käyttäjän luonti",
        mFileIds: [
            "0-269009-1-349366", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohje on tarkoitettu henkilölle, joka vastaa osapuolen B2B-sanomarajapintakäyttäjästä. Datahubia varten määritetään kullekin osapuolelle pääkäyttäjä, 
            joka pääsee datahubin käyttöliittymässä ylläpitämään B2B-sanomarajapintakäyttäjän käyttöoikeuksia. B2B-sanomarajapintakäyttäjä on tekninen 
            järjestelmäkäyttäjäidentiteetti, jolle osapuolen käyttöoikeudet määritetään.
        `,
    },
];

const guiUserCreation: DocumentDescription[] = [
    {
        name: "Käyttöliittymäkäyttäjän luonti",
        mFileIds: [
            "0-238244-1-305843", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohje on tarkoitettu henkilölle, joka vastaa osapuolen käyttäjien luonnista, tyypillisesti osapuolen oma pääkäyttäjä. 
            Datahubin käyttäjät koostuvat aina käyttäjäidentiteetistä sekä tälle annetuista käyttöoikeuksista/rooleista. 
            Tämän kaksijakoisuuden vuoksi käyttäjä luodaan ikään kuin kahdessa osassa. Ensin luomalla identiteetti, jolla käyttäjä kirjautuu järjestelmään, 
            ja sitten antamalla tälle käyttäjälle käyttöoikeudet. Kirjautumisessa käytetään TOTP-teknologiaan perustuvaa kaksivaiheista tunnistautumista.
        `,
    },
];

const organisationUserCreation: DocumentDescription[] = [
    {
        name: "Instruction for organization in creating users",
        mFileIds: [
            "0-235959-1-300774", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document provides instructions for creating organisation/GUI users and B2B/system users.
        `,
    },
];

const gs1IDsInElectricityRetailMarket: DocumentDescription[] = [
    {
        name: "GS1-tunnuksien käyttö sähkön vähittäismarkkinoilla",
        mFileIds: [
            "0-227066-8-287101", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Dokumentissa esitellään GS1-järjestelmä yleisesti ja kuvataan, miten GS1-tunnuksia käytetään datahubissa.
        `,
        description: `
            <p>
                Sähkön vähittäismarkkinoilla jokaisella käyttöpaikalla, osapuolella, mittausalueella, rajapistemittauksella ja tuotantoyksiköllä on yksilöllinen tunniste, 
                jota käytetään yleisesti markkinaosapuolten välisessä tiedonvaihdossa. Datahubissa käytetään GS1-tunnuksia käyttöpaikkojen ja osapuolten yksilöivien tunnuksien osalta.
            </p>
            <p>
                Dokumentissa esitellään GS1-järjestelmä yleisesti ja kuvataan, miten GS1-tunnuksia käytetään datahubissa.
            </p>
            <p>
                2. luku: GS1-organisaatio ja sen ylläpitämät tunnukset. Luvussa esitellään erityisesti ne tunnukset, joita käytetään Suomen sähkömarkkinoilla:
                <ul>
                    <li>GLN - osapuolitunniste (osapuolitunnus datahubissa)</li>
                    <li>GSRN - maailmanlaajuinen palvelusuhteen numero (mittauspisteen tunnus datahubissa)</li>
                </ul>
            </p>
            <p>
                3. luku: GS1-tunnusten hankkiminen ja organisaatiomuutosten vaikutukset GS1-tunnusten käyttöön.
            </p>
        `,
    },
    {
        name: "Using GS1 IDs in the electricity retail market",
        mFileIds: [
            "0-233044-6-295835", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document introduces the GS1 system in general and describes the use of GS1 IDs in Datahub.
        `,
        description: `
            <p>
                In the electricity retail market, each accounting point, party, metering grid area, exchange point and production 
                unit must have a unique identifier commonly used when exchanging information between market parties. In Datahub, 
                GS1 IDs are used for accounting points and unique party IDs.
            </p>
            <p>
                This document introduces the GS1 system in general and describes how GS1 IDs are used in Datahub.
            </p>
            <p>
                Chapter 2 presents the GS1 organisation and the IDs it maintains. The chapter focuses on the IDs that are used on 
                the Finnish electricity market:
                <ul>
                    <li>GLN - Party ID (party ID in Datahub)</li>
                    <li>GSRN - Global Service Relation Number (metering point ID in Datahub)</li>
                </ul>
            </p>
            <p>
                Chapter 3 provides instructions on obtaining GS1 IDs and the effects of organisational changes on the use of GS1 IDs.
            </p>
        `,
    },
];

const datahubServiceRequest: DocumentDescription[] = [
    {
        name: "Toimeksiannon ilmoituslomake",
        mFileIds: [
            "0-273661-6-356560", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Datahub-operaattori hallinnoi toimeksiantoja markkinaosapuolten palvelupyyntöjen perusteella. Toimeksiannot ilmoitetaan Excel-lomakkeella, 
            joka on saatavilla Datahub Palvelut -portaalissa. Täytetty Excel-lomake tulee ilmoittaa palvelupyynnön liitteenä. Palvelupyynnöt 
            tehdään Datahub tukipalvelun kautta.
        `,
    },
];

const datahubServiceRequestInstructions: DocumentDescription[] = [
    {
        name: "Toimeksianto-ohje",
        mFileIds: [
            "0-273660-4-356559", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohje tarkentaa ”Sähkön vähittäismarkkinoiden liiketoimintaprosessit datahubissa” dokumentin luvussa 3.9.2 ”Osapuolten 
            osapuolivaltuutukset ja toimeksiannot” kuvattujen osapuolten välisten toimeksiantojen ja osapuolivaltuutusten hallintaa 
            ja käyttöä datahubin sanomarajapinnassa.
        `,
    },
];

const instructionsForPartiesInExceptionalCircumstances: DocumentDescription[] = [
    {
        name: "Ohje osapuolille poikkeustilanteisiin varautumisesta",
        mFileIds: [
            "0-321361-5-421207", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Ohje on tarkoitettu Datahubiin liittyneille jakeluverkonhaltijoille, sähkömyyjille sekä muille verkonhaltijoille tukemaan 
            kyseisten osapuolten varautumista poikkeustilanteisiin, joista johtuen datahub-järjestelmän sanomarajapiannan saatavuus 
            voi olla rajoitettua tai pois käytöstä.
        `,
    },
    {
        name: "Instructions for parties on preparations for exceptional circumstances",
        mFileIds: [
            "0-333458-3-438348", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            These instructions are intended to support distribution system operators, electricity suppliers, and other network operators in 
            preparing for exceptional circumstances that could result in the impaired availability or outage of the Datahub System's 
            messaging interface.
        `,
    },
];

const emailExchangeInExceptionalCircumstances: DocumentDescription[] = [
    {
        name: "Sähköpostitiedonvaihto poikkeustilanteissa",
        mFileIds: [
            "0-321359-3-421205", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Poikkeustilanteen tiedonvaihtoa käytetään operaattorin erikseen ilmoittamissa poikkeustilanteissa koko toimialalla. 
            Pohjia voi hyödyntää myös tilanteissa, joissa yksittäisen osapuolen osalta joudutaan hetkellisesti käyttämään muuta 
            tiedonvaihtoratkaisua kuin datahubia.
        `,
    },
];

const emailTemplatesInstructions: DocumentDescription[] = [
    {
        name: "Mallisähköpostit ohje",
        mFileIds: [
            "0-293394-1-387118", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Poikkeustilanteen tiedonvaihtoa käytetään operaattorin erikseen ilmoittamissa poikkeustilanteissa koko toimialalla. 
            Pohjia voi hyödyntää myös tilanteissa, joissa yksittäisen osapuolen osalta joudutaan hetkellisesti käyttämään muuta 
            tiedonvaihtoratkaisua kuin datahubia.
        `,
    },
];

const emailTemplates: DocumentDescription[] = [
    {
        name: "Exceptional situation email templates (Unofficial translation)",
        mFileIds: [
            "0-309970-1-404605", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            Exceptional information exchange is used in exceptional situations. The operator notifies the industry separately in case an exceptional situation should occur. 
            The email templates can also be used in situations where an individual party has to temporarily use a data exchange solution other than Datahub.
        `,
    },
    {
        name: "Mallisähköpostit",
        mFileIds: [
            "0-293395-4-387119", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Tästä zip-tiedostosta löytyy seuraavat sähköpostipohjat: kytkentäilmoitus, käyttöpaikkatunnuksen kysely, käyttöpaikkatunnuksen toimitus, 
            loppulaskutusosoitteen ilmoitus, myyjänvaihdon peruutus, pikamuutto, sisäänmuuton peruutus, sisäänmuutosta johtuva ulosmuutto, 
            sisäänmuutto, sisäänmuuttopäivän muutos, toimituksen aloituksen peruutus, toimituksen päättymisen peruutus myyjänvaihdon peruunnuttua, 
            toimituksen päättymisen peruutus ulosmuuton peruunnuttua, ulosmuuton peruutus, ulosmuutto, ulosmuuttopäivän muutos.
        `,
    },
];

const datahubPrivacyPractices: DocumentDescription[] = [
    {
        name: "Datahub Tietosuojakäytännöt toimialalle",
        mFileIds: [
            "0-318820-1-416996", // Testi & Tuot
        ],
        locale: "fi",
        excerpt: `
            Dokumentti koostaa tietosuojaan liittyvät ohjeistukset markkinaosapuolille. Sisältö: henkilötietojen käsittelyn tausta, tietosuoja, 
            tietoturva, tietoturvaloukkaukset ja niiden käsittely, henkilötietojen käsittely testauksessa ja sertifioinnissa.
        `,
    },
    {
        name: "Datahub Privacy Practices for the industry",
        mFileIds: [
            "0-329864-1-433777", // Testi & Tuot
        ],
        locale: "en",
        excerpt: `
            This document contains data protection guidelines for market parties. Contents include: Background to the processing of personal data, 
            Data protection, Information security, Personal data breaches and how to deal with them, Processing of personal data during testing and 
            certification.
        `,
    },
];

const e66BatchInterfaceGuidelines: DocumentDescription[] = [
    {
        name: "Datahub - E66 Batch Interface Guidelines",
        locale: "en",
        mFileIds: ["0-481497-2-644285"],
        excerpt: `
            This document outlines how the existing E66 batch interface is to be be used for more frequent delivery of 
            metering data, starting from January 1, 2026. It contains recommendations for message size and frequency of delivery. 
            It also describes the impact this more frequent delivery will have on different parties.
        `,
    },
];

const descriptions = [
    ...electricityRetailMarketBusinessProcesses,
    ...electricityRetailMarketBusinessProcessesChanges,
    ...datahubEvents,
    ...datahubEventChanges,
    ...dataStandard,
    ...datahubProcessMap,
    ...processDiagrams,
    ...memoOnSynteticTestData,
    ...marketPartyTestGuide,
    ...b2bMessageInterfaceConnection,
    ...datahubReleaseNotes,
    ...datahubFingridSchemas,
    ...datahubDataInterface,
    ...datahubExternalInterfaceSpec,
    ...datahubValidationRules,
    ...validationRulesDH200,
    ...datahubNameAndAddressStructureGuide,
    ...datahubSupportServiceInstructions,
    ...inferringProcesses,
    ...partysContactPersonManagement,
    ...partyRetrievalFromDatahub,
    ...thirdPartyInstructions,
    ...datahubProcessTimeLimits,
    ...partiesWithMeasurementResponsibility,
    ...datahubUIUserManualForParties,
    ...datahubControlReports,
    ...datahubGUIMDMUserManualForMarketParties,
    ...datahubGUISMTUserManualForMarketParties,
    ...datahubGUIUserManualOfBasicFunctionalitiesForMarketParties,
    ...sslCertificateRetrievalInstructions,
    ...b2BUserCreation,
    ...guiUserCreation,
    ...organisationUserCreation,
    ...gs1IDsInElectricityRetailMarket,
    ...datahubServiceRequest,
    ...datahubServiceRequestInstructions,
    ...instructionsForPartiesInExceptionalCircumstances,
    ...emailExchangeInExceptionalCircumstances,
    ...emailTemplatesInstructions,
    ...emailTemplates,
    ...datahubPrivacyPractices,
    ...e66BatchInterfaceGuidelines,
];

export default descriptions;
